'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _reactRedux = require('react-redux');

var _translate = require('../../redux/i18n/translate');

var _translate2 = _interopRequireDefault(_translate);

var _RotateDevice = require('./RotateDevice');

var _RotateDevice2 = _interopRequireDefault(_RotateDevice);

var _Chat = require('components/Chat');

var _components = require('components');

var _preloadAssets = require('utils/preloadAssets');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Mobile = (_dec = (0, _reactRedux.connect)(function (state, props) {
  return { currentLanguage: state.language.lang };
}, {}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Mobile, _Component);

  function Mobile(props) {
    (0, _classCallCheck3.default)(this, Mobile);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Mobile.__proto__ || (0, _getPrototypeOf2.default)(Mobile)).call(this, props));

    _this.playVideo = function (fullscreen) {
      var myVideo = _this.refs.video;

      myVideo.load();
      myVideo.play();
      if (fullscreen) {
        if (typeof myVideo.webkitEnterFullscreen != "undefined") {
          // This is for Android Stock.
          myVideo.webkitEnterFullscreen();
        } else if (typeof myVideo.webkitRequestFullscreen != "undefined") {
          // This is for Chrome.
          myVideo.webkitRequestFullscreen();
        } else if (typeof myVideo.mozRequestFullScreen != "undefined") {
          myVideo.mozRequestFullScreen();
        }
      }
    };

    _this.stopVideo = function () {
      var myVideo = _this.refs.video;
      myVideo.stop();
    };

    _this.showMediaElement = function (e) {

      var mediaType = e.currentTarget.dataset.mediaType;

      if (mediaType === "video") {
        var videoSrc = e.currentTarget.dataset.mediaSrc;
        var videoSrcSubtitles = e.currentTarget.dataset.mediaSrcSubtitles;
        _this.setState({
          videoSrc: videoSrc,
          videoSrcSubtitles: videoSrcSubtitles,
          showVideo: true
        });
        _this.playVideo(true);
      } else {
        var imageSrc = e.currentTarget.dataset.mediaSrc;
        _this.setState({
          imageSrc: imageSrc,
          showImage: true
        });
      }
    };

    _this.prepareMediaElements = function (elements) {
      //Ahora procedemos a preparar la estructura de elementos media...
      var mediaElements = elements.reduce(function (result, item) {
        // Si es un elemento que se convertirá en un elemento Media...
        if (item.hasOwnProperty("showMedia")) {
          result.push({ // Este será nuestro "map" del array
            elements: item.showMedia.elements,
            srcThumbnail: item.showMedia.srcThumbnail,
            title: item.showMedia.title,
            mediaId: item.showMedia.mediaId
          });
        }
        return result;
      }, []);

      _this.preloadAssets(_this.context.baseUrl, mediaElements);
    };

    _this.state = {
      loading: true,
      progress: 0,
      conversationDone: false,
      showVideo: false,
      showImage: false,
      videoSrc: '',
      videoSrcSubtitles: '',
      imageSrc: '',
      full: false
    };

    _this.playVideo = _this.playVideo.bind(_this);
    _this.addProgress = _this.addProgress.bind(_this);
    _this.setConversationDone = _this.setConversationDone.bind(_this);
    _this.connect = _this.connect.bind(_this);
    _this.exitHandler = _this.exitHandler.bind(_this);
    _this.hideImage = _this.hideImage.bind(_this);
    _this.preloadAssets = _this.preloadAssets.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Mobile, [{
    key: 'addProgress',
    value: function addProgress() {
      var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.setState({
        progress: this.state.progress + amount
      });
    }
  }, {
    key: 'setConversationDone',
    value: function setConversationDone() {
      var _this2 = this;

      this.setState({
        conversationDone: true
      }, function () {
        _this2.scrollToBottom();
      });
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {

      if (document.getElementsByClassName('choices')[0].classList.contains('noChoices')) {
        this.refs.conversation.showMessagesBlock();
        //console.log('visible')
      } else {
          //document.getElementsByClassName('swipeMobile')[0].classList.add('hide');
          //console.log('oculto')
        }
    }
  }, {
    key: 'scrollToBottom',
    value: function scrollToBottom() {
      $("#scrollMobileContainer").animate({ scrollTop: $('#scrollMobileContainer').prop("scrollHeight") }, 1000);
    }
  }, {
    key: 'hideImage',
    value: function hideImage() {
      this.setState({
        showImage: false
      });
    }
  }, {
    key: 'connect',
    value: function connect() {
      document.getElementsByClassName('titleImg')[0].classList.add('hide');

      this.setState({
        loading: false
      });
    }
  }, {
    key: 'exitHandler',
    value: function exitHandler() {

      if (this.state.full) {
        //salimos
        this.setState({
          full: false
        });
        this.refs.video.pause();
        this.refs.video.volume = 0;
      } else {
        //entramos
        this.setState({
          full: true
        });
        this.refs.video.volume = 1;
        this.playVideo(true);
      }

      /*
      if (document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement !== null)
      {
        this.stopVideo();
        this.setState({  
          showVideo: false
        });
      }
      */
    }
  }, {
    key: 'attachMediaHandlers',
    value: function attachMediaHandlers() {
      if (document.addEventListener) {
        document.addEventListener('webkitfullscreenchange', this.exitHandler, false);
        document.addEventListener('mozfullscreenchange', this.exitHandler, false);
        document.addEventListener('fullscreenchange', this.exitHandler, false);
        document.addEventListener('MSFullscreenChange', this.exitHandler, false);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.timeout = setTimeout(this.connect, this.props.connectedTime);
      this.attachMediaHandlers();

      var mergedMessages = [].concat.apply([], this.props.strings.messages);
      this.prepareMediaElements(mergedMessages);
    }
  }, {
    key: 'preloadAssets',
    value: function preloadAssets(baseUrl, mediaElements) {
      var arrangedMediaElements = mediaElements.reduce(function (result, item) {
        item.elements.forEach(function (mediaElement) {
          if (mediaElement.type === "image" || mediaElement.type === "video") {
            result.push({ src: baseUrl + '/' + mediaElement.src });
          }
        });
        result.push({ src: baseUrl + '/' + item.srcThumbnail });
        return result;
      }, []);

      // Llamamos a la función loadAssets de util/preloadAssets
      (0, _preloadAssets.loadAssets)(arrangedMediaElements);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$strings = this.props.strings,
          logo = _props$strings.logo,
          start = _props$strings.start,
          connecting = _props$strings.connecting,
          connected = _props$strings.connected,
          endText = _props$strings.endText,
          messages = _props$strings.messages,
          trailer = _props$strings.trailer;

      var connectText = this.state.loading ? connecting : connected;
      var connectClass = (0, _classnames2.default)({
        'connect': true,
        'loading': this.state.loading
      });

      var mediaVideoClass = (0, _classnames2.default)({
        'mediaVideo': true,
        'show': this.state.showVideo
      });

      var mediaImageClass = (0, _classnames2.default)({
        'mediaImage': true,
        'show': this.state.showImage
      });

      var conversationWrapperClass = (0, _classnames2.default)({
        'conversationWrapper': true,
        'hideOverflow': this.state.loading,
        'showFooter': this.state.conversationDone,
        'hideSwipe': this.state.conversationDone
      });

      var content = void 0;
      if (!this.state.loading) {
        content = _react2.default.createElement(_Chat.Conversation, { mobile: true, key: 'conversation', ref: 'conversation', elemToScroll: '#scrollMobileContainer', height: 300, messages: messages, addProgress: this.addProgress, setConversationDone: this.setConversationDone, conversationDone: this.state.conversationDone, showMediaElement: this.showMediaElement, currentLanguage: this.props.currentLanguage });
      } else {
        content = _react2.default.createElement(
          'div',
          { key: 'loading', className: 'loading' },
          _react2.default.createElement(
            'div',
            { className: 'titleImg' },
            _react2.default.createElement('img', { src: this.context.baseUrl + logo + this.state.imageSrc })
          ),
          _react2.default.createElement(_components.LoadingCircle, null),
          _react2.default.createElement(_components.PointsAndSvg, { generalClass: 'withoutPoints', icon: '' })
        );
      }

      return _react2.default.createElement(
        'div',
        { id: 'mobileContent' },
        _react2.default.createElement(
          'div',
          { className: 'mobile' },
          _react2.default.createElement(
            'div',
            { className: 'connectBar table' },
            _react2.default.createElement(
              'div',
              { className: 'cell' },
              _react2.default.createElement('span', { className: connectClass }),
              _react2.default.createElement(
                'span',
                { className: 'text' },
                connectText
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: conversationWrapperClass, id: 'scrollMobileContainer' },
            _react2.default.createElement(
              'div',
              { className: 'upperConversation' },
              _react2.default.createElement(
                _reactAddonsCssTransitionGroup2.default,
                { transitionName: 'view', transitionAppear: true, transitionAppearTimeout: 1500, transitionEnter: true, transitionEnterTimeout: 1000, transitionLeave: true, transitionLeaveTimeout: 1000 },
                content
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'lowerConversation' },
              _react2.default.createElement(
                'footer',
                null,
                _react2.default.createElement(
                  'span',
                  { className: 'endText' },
                  _react2.default.createElement('span', { className: 'line' }),
                  endText,
                  _react2.default.createElement('span', { className: 'line' })
                ),
                _react2.default.createElement(
                  'div',
                  { onClick: this.showMediaElement, className: 'nextView', 'data-media-src': trailer.src, 'data-media-src-subtitles': trailer.srcSubtitles, 'data-media-type': 'video' },
                  _react2.default.createElement(
                    'span',
                    null,
                    trailer.text
                  )
                ),
                _react2.default.createElement(_components.RRSS, { rrssVisible: '',
                  url: "http://lab.rtve.es/" + this.context.project + "/",
                  twUrl: this.props.urlShare,
                  twText: this.props.twTxt,
                  analytics: false })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: mediaVideoClass },
              _react2.default.createElement(
                'video',
                { controls: true, ref: 'video', preload: true },
                _react2.default.createElement('source', { src: this.context.baseUrl + '/' + this.state.videoSrc, type: 'video/mp4' }),
                _react2.default.createElement('track', { src: this.context.baseUrl + '/' + this.state.videoSrcSubtitles, kind: 'subtitles', srcLang: 'es', label: 'Spanish' }),
                'Your browser does not support the video tag.'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: mediaImageClass, onClick: this.hideImage },
              _react2.default.createElement(
                'div',
                { className: 'imageWrapper' },
                _react2.default.createElement('img', { src: this.context.baseUrl + '/' + this.state.imageSrc, alt: 'Guerra a la Mentira - Lab RTVE' })
              ),
              _react2.default.createElement(
                'span',
                { className: 'close' },
                _react2.default.createElement('i', { className: 'icon-close' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'swipeMobile', onClick: this.handleClick },
              _react2.default.createElement('i', { className: 'icon-mobile-down' })
            )
          ),
          _react2.default.createElement(_RotateDevice2.default, null)
        )
      );
    }
  }]);
  return Mobile;
}(_react.Component), _class2.propTypes = {
  strings: _react.PropTypes.object,
  connectedTime: _react.PropTypes.number
}, _class2.contextTypes = {
  baseUrl: _react.PropTypes.string.isRequired,
  project: _react.PropTypes.string.isRequired
}, _temp)) || _class);
exports.default = (0, _translate2.default)('Mobile')(Mobile);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Mobile.js
// module id = 796
// module chunks = 0